// extracted by mini-css-extract-plugin
export default {"form":"ConfirmPassword_form__R5mJ0"};